/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import makeAnimated from "react-select/animated";
import Select from "react-select";
//components
import ClideLoader from "app/shared/ui-kit/loader";
//assets
import {
  PlusIconRed,
  RoundSave,
  CrossRound,
  RoundDelete,
  RoundEdit,
} from "assets/Iconsv2/Iconsv2";
import { useTranslation } from "react-i18next";
const animatedComponents = makeAnimated();
const DetailStep1 = ({ state, functionContent, variablesObj }) => {
  const { isApproveEnabled } = variablesObj ?? {};
  const { origin } = useParams();
  const { nmDetail } = state;
  const { t } = useTranslation(["nm", "util"]);
  return (
    <div>
      <div className="row mt-3">
        <div className="col-12 col-md-12 col-lg-12">
          <div className="col-12 col-lg-12 col-md-12 d-flex justify-content-between px-0">
            <div className="clide-v2-title mb-1">
              <label className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                {" "}
                {t("step1IncidentAnalysisQuestion")}
              </label>
            </div>
            <div className="d-flex align-items-center">
              {/* Search Bar */}
              {/* <div className="input-group me-3" style={{ width: '300px' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('searchByIncidentAnalysis')}
                  aria-label="Search"
                  aria-describedby="button-addon2"
                  value={state.incidentAnalysisSearchText || ''}
                  onChange={(e) =>
                    functionContent.setState({
                      incidentAnalysisSearchText: e.target.value
                    })
                  }
                />
                <button
                  className="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                  type="button"
                  id="button-addon2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="#F56620"
                      d="M8.333 3.334a5 5 0 100 10 5 5 0 000-10zm-6.666 5A6.667 6.667 0 1113.6 12.422l4.49 4.49a.833.833 0 01-1.18 1.178l-4.488-4.49A6.667 6.667 0 011.667 8.334z"
                    ></path>
                  </svg>
                </button>
              </div> */}
              {state.reportStatus === "progress" &&
              isApproveEnabled &&
              origin !== "kanbanarchive" ? (
                <button
                  className="clide-v2-icon-btn "
                  onClick={() => {
                    functionContent.toggleAddQuestionTab();
                  }}
                >
                  <PlusIconRed />
                </button>
              ) : null}
            </div>
          </div>

          {nmDetail.nm_reported_detail_incidence_analysis_question?.length ? (
            <div className="border p-2 rounded  w-100">
              <Row>
                <Col md={12}>
                  <Scrollbars
                    style={{ height: "15rem" }}
                    renderView={(props) => (
                      <div
                        style={{
                          paddingRight: "15px",
                          paddingBottom: "1rem",
                          ...props.style,
                          overflowX: "hidden",
                        }}
                      />
                    )}
                  >
                    {nmDetail.nm_reported_detail_incidence_analysis_question?.map(
                      (el, idx) => (
                        <div className="row">
                          <div className="col-md-10 col-lg-10 col-12  px-0">
                            <div class="clide-v2-title mb-1">
                              <label class="clide-v2-fs-4 w-space-nobreak">
                                {t("q")} {idx + 1} - {el?.question}
                              </label>
                            </div>
                            <div class="clide-v2-title mb-1">
                              <label class="clide-v2-fs-4 fw-normal w-space-nobreak">
                                {t("ans")} - {el?.response}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 col-lg-2 col-12  px-0 d-flex justify-content-end">
                            {state?.reportStatus === "progress" &&
                            isApproveEnabled &&
                            origin !== "kanbanarchive" ? (
                              <button
                                className="clide-v2-icon-btn my-2"
                                onClick={() =>
                                  functionContent.setState({
                                    deleteQuestionId: el?.question_id,
                                  })
                                }
                              >
                                <RoundDelete />
                              </button>
                            ) : null}
                          </div>
                        </div>
                      ),
                    )}
                  </Scrollbars>
                </Col>
              </Row>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DetailStep1;
